"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var Container_1 = __importDefault(require("../Container/Container"));
var Theme_1 = require("../../Theme");
var SaurIcon_1 = __importDefault(require("../../Icons/SaurIcon"));
var sepig_1 = __importDefault(require("../../Icons/sepig"));
var Se3r_1 = __importDefault(require("../../Icons/Se3r"));
var accm_1 = __importDefault(require("../../Icons/accm"));
var cer_1 = __importDefault(require("../../Icons/cer"));
var cgsp_1 = __importDefault(require("../../Icons/cgsp"));
var saur_guadeloupe_1 = __importDefault(require("../../Icons/saur-guadeloupe"));
var cise_reunion_1 = __importDefault(require("../../Icons/cise-reunion"));
var eau_de_garonne_1 = __importDefault(require("../../Icons/eau-de-garonne"));
var atlantic_eau_1 = __importDefault(require("../../Icons/atlantic-eau"));
var sem_1 = __importDefault(require("../../Icons/sem"));
var grand_lac_1 = __importDefault(require("../../Icons/grand-lac"));
var saint_affo_1 = __importDefault(require("../../Icons/saint-affo"));
var saint_martin_1 = __importDefault(require("../../Icons/saint-martin"));
var sateg_1 = __importDefault(require("../../Icons/sateg"));
var sudeau_1 = __importDefault(require("../../Icons/sudeau"));
var eaux_saumur_val_de_loire_1 = __importDefault(require("../../Icons/eaux-saumur-val-de-loire"));
var eau_du_morbihan_1 = __importDefault(require("../../Icons/eau-du-morbihan"));
var derichebourg_1 = __importDefault(require("../../Icons/derichebourg"));
var siaep_questembert_1 = __importDefault(require("../../Icons/siaep-questembert"));
var sepra_1 = __importDefault(require("../../Icons/sepra"));
var sieccao_1 = __importDefault(require("../../Icons/sieccao"));
var ileo_1 = __importDefault(require("../../Icons/ileo"));
var sbaa_1 = __importDefault(require("../../Icons/sbaa"));
var gmva_1 = __importDefault(require("../../Icons/gmva"));
var Martinique_1 = __importDefault(require("../../Icons/Martinique"));
var Vilivia_1 = __importDefault(require("../../Icons/Vilivia"));
var gpeau_1 = __importDefault(require("../../Icons/gpeau"));
var AppLogo = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'normal' : _c, content = _a.content, forceBrand = _a.forceBrand, _d = _a.version, version = _d === void 0 ? 1 : _d;
    var injectProps = __assign({}, (content ? { content: content } : {}));
    var themeContext = react_1.useContext(styled_components_1.ThemeContext);
    var brandName = themeContext.name;
    function renderLogo(brand) {
        switch (brand) {
            case 'accm':
                return {
                    normal: function (props) { return react_1.default.createElement(accm_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(accm_1.default, __assign({}, props)); }
                };
            case 'atlantic-eau':
                return {
                    normal: function (props) { return react_1.default.createElement(atlantic_eau_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(atlantic_eau_1.default, __assign({}, props)); }
                };
            case 'sem':
                return {
                    normal: function (props) { return react_1.default.createElement(sem_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sem_1.default, __assign({}, props)); }
                };
            case 'cer':
                return {
                    normal: function (props) { return react_1.default.createElement(cer_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(cer_1.default, __assign({}, props)); }
                };
            case 'cgsp':
                return {
                    normal: function (props) { return react_1.default.createElement(cgsp_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(cgsp_1.default, __assign({}, props)); }
                };
            case 'saur-guadeloupe':
                return {
                    normal: function (props) { return react_1.default.createElement(saur_guadeloupe_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(saur_guadeloupe_1.default, __assign({}, props)); }
                };
            case 'cise-reunion':
                return {
                    normal: function (props) { return react_1.default.createElement(cise_reunion_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(cise_reunion_1.default, __assign({}, props)); }
                };
            case 'eau-de-garonne':
                return {
                    normal: function (props) { return react_1.default.createElement(eau_de_garonne_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(eau_de_garonne_1.default, __assign({}, props)); }
                };
            case 'eaux-saumur-val-de-loire':
                return {
                    normal: function (props) { return react_1.default.createElement(eaux_saumur_val_de_loire_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(eaux_saumur_val_de_loire_1.default, __assign({}, props)); }
                };
            case 'grand-lac':
                return {
                    normal: function (props) { return react_1.default.createElement(grand_lac_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(grand_lac_1.default, __assign({}, props)); }
                };
            case 'saint-affo':
                return {
                    normal: function (props) { return react_1.default.createElement(saint_affo_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(saint_affo_1.default, __assign({}, props)); }
                };
            case 'saint-martin':
                return {
                    normal: function (props) { return react_1.default.createElement(saint_martin_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(saint_martin_1.default, __assign({}, props)); }
                };
            case 'sateg':
                return {
                    normal: function (props) { return react_1.default.createElement(sateg_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sateg_1.default, __assign({}, props)); }
                };
            case 'saur':
                return {
                    normal: function (props) { return (react_1.default.createElement(SaurIcon_1.default, __assign({}, props, { color: themeContext.colors.primaryDark }))); },
                    lighten: function (props) { return (react_1.default.createElement(SaurIcon_1.default, __assign({}, props, { color: Theme_1.colors.white }))); }
                };
            case 'saur-derichebourg-aoi':
                return {
                    normal: function (props) { return react_1.default.createElement(derichebourg_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(derichebourg_1.default, __assign({}, props)); }
                };
            case 'saur-eau-du-morbihan':
                return {
                    normal: function (props) { return react_1.default.createElement(eau_du_morbihan_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(eau_du_morbihan_1.default, __assign({}, props)); }
                };
            case 'se3r':
                return {
                    normal: function (props) { return react_1.default.createElement(Se3r_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(Se3r_1.default, __assign({}, props)); }
                };
            case 'saur-martinique':
                return {
                    normal: function (props) { return react_1.default.createElement(Martinique_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(Martinique_1.default, __assign({}, props)); }
                };
            case 'vilivia':
                return {
                    normal: function (props) { return react_1.default.createElement(Vilivia_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(Vilivia_1.default, __assign({}, props)); }
                };
            case 'saur-gpeau':
                return {
                    normal: function (props) { return react_1.default.createElement(gpeau_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(gpeau_1.default, __assign({}, props)); }
                };
            case 'sepig':
                return {
                    normal: function (props) { return react_1.default.createElement(sepig_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sepig_1.default, __assign({}, props)); }
                };
            case 'sudeau':
                return {
                    normal: function (props) { return react_1.default.createElement(sudeau_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sudeau_1.default, __assign({}, props)); }
                };
            case 'siaep-questembert':
                return {
                    normal: function (props) { return react_1.default.createElement(siaep_questembert_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(siaep_questembert_1.default, __assign({}, props)); }
                };
            case 'sepra':
                return {
                    normal: function (props) { return react_1.default.createElement(sepra_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sepra_1.default, __assign({}, props)); }
                };
            case 'sieccao':
                return {
                    normal: function (props) { return react_1.default.createElement(sieccao_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sieccao_1.default, __assign({}, props)); }
                };
            case 'ileo':
                return {
                    normal: function (props) { return react_1.default.createElement(ileo_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(ileo_1.default, __assign({}, props)); }
                };
            case 'sbaa':
                return {
                    normal: function (props) { return react_1.default.createElement(sbaa_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(sbaa_1.default, __assign({}, props)); }
                };
            case 'gmva':
                return {
                    normal: function (props) { return react_1.default.createElement(gmva_1.default, __assign({}, props)); },
                    lighten: function (props) { return react_1.default.createElement(gmva_1.default, __assign({}, props)); }
                };
            default:
                return {
                    normal: function (props) { return (react_1.default.createElement(SaurIcon_1.default, __assign({}, props, { color: themeContext.colors.primaryDark }))); },
                    lighten: function (props) { return (react_1.default.createElement(SaurIcon_1.default, __assign({}, props, { color: Theme_1.colors.white }))); }
                };
        }
    }
    if (version === 2) {
        var selectedBrand = (forceBrand || brandName).toLowerCase();
        return (react_1.default.createElement(Container_1.default, { className: "sds-app-logo " + className },
            react_1.default.createElement("img", { src: "https://sr-b2c-dev-endpoint-01.azureedge.net/theme/Saur/brands/" + content + "/" + selectedBrand + ".svg" })));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container_1.default, { className: "sds-app-logo " + className },
                type === 'normal' &&
                    renderLogo(forceBrand || brandName).normal(injectProps),
                type === 'lighten' &&
                    renderLogo(forceBrand || brandName).lighten(injectProps)),
            react_1.default.createElement("div", { className: "helper-fix-logo " + type + "-logo " + content + "-logo" })));
    }
};
exports.default = AppLogo;
